export default __webpack_public_path__ + "static/media/logomarca.a41fbf76.png";